export const businessCaseSearchParams = {
  create: 'create',
  testDriveEdit: 'editTestDrive',
  businessCaseDetail: {
    overview: 'overview',
    customer: 'customer',
    buying: 'buying',
    selling: 'selling',
    testDrive: 'test-drive',
    checkout: 'checkout',
    documents: 'documents',
    reservations: 'reservations',
  },
};
